export default function SectionLabel({ children }: { children: string }) {
  return (
    <p className="flex lg:hidden items-center justify-center sm:justify-start gap-2 text-cmp-gold text-xs font-bold uppercase tracking-widest text-center">
      {/* <span className="h-px w-5 bg-cmp-gold/40" aria-hidden="true" /> */}
      {children}
      {/* <span className="h-px w-5 bg-cmp-gold/40" aria-hidden="true" /> */}
    </p>
  )
}
